import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IComponentOptions, IController, IModule, ITimeoutService} from "angular";

const css = require('./mdButtonMedBekreftKlikk.scss');

export function registrerMButtonMedBekreftKlikkKomponent(angular: IModule) {
    angular
        .component('wkMdButtonMedBekreftKlikk', mdButtonMedBekreftKlikkKomponentDef());
}

function mdButtonMedBekreftKlikkKomponentDef(): IComponentOptions {
    return {
        bindings: {
            klikk: "&",
            bekreftKlikk: "@",
            mdClass: "@",
        },
        controller: MdButtonMedBekreftKlikkKontroller.forInjisering(),
        template: require('./mdButtonMedBekreftKlikk.html'),
        transclude: true
    };
}

export class MdButtonMedBekreftKlikkKontroller implements IController {
    static forInjisering() {
        return [
            regNavn.ng.$timeout,
            MdButtonMedBekreftKlikkKontroller
        ]
    }

    constructor(private $timeout: ITimeoutService) {
    }

    klikk: Function; //settes via bindings
    bekreftKlikk: string; //settes via bindings
    mdClass: string; //settes via bindings

    erVisBekreftKlikkSteg = false;

    private visBekreftKlikkStegTidsstempel:number;
    private visBekreftKlikkStegTimeout = null;

    vedKlikk($event) {
        return this.erVisBekreftKlikkSteg ?
            this.kallKlikk($event) :
            this.visBekreftKlikkSteg();
    }

    $onInit(): void {
    }

    //hjelpemetoder

    private visBekreftKlikkSteg() {
        this.erVisBekreftKlikkSteg = true;
        this.visBekreftKlikkStegTidsstempel = new Date().getTime();
        this.visBekreftKlikkStegTimeout = this.$timeout(() => this.resetBekreftKlikk(), 1000 * 10);
    }

    private resetBekreftKlikk() {
        this.erVisBekreftKlikkSteg = false;
    }

    private kallKlikk($event) {
        //ikke utfør handling med mindre det har gått minst 500ms siden initielt klikk
        if ((new Date().getTime() - this.visBekreftKlikkStegTidsstempel) < 500) return;

        this.$timeout.cancel(this.visBekreftKlikkStegTimeout);
        this.resetBekreftKlikk();
        if (this.klikk) this.klikk({$event: $event});
    }

}

